import { jsx as _jsx } from "react/jsx-runtime";
import Flex from '../../atoms/Flex';
import styled from 'styled-components';
import { color } from '../../templates/Ui';
export const FilterGroupBackdrop = styled.div `
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1;
    background: black;
    opacity: 0.5;
    display: none;

    [aria-haspopup='true'][aria-expanded='true'] & {
        display: block;
    }
`;
const StyledFlex = styled(Flex) `
    border-bottom: 1px solid ${color.border.base};

    @media only screen and (max-width: 768px) {
        flex-wrap: wrap;
    }

    [aria-haspopup='true'][aria-expanded='false'] & {
        display: none;
    }

    [aria-haspopup='true'][aria-expanded='true'] & {
        display: block;
        background: white;
        border-radius: 6px;
        padding: 2rem;
        padding-top: 100px;
        position: fixed;
        top: 0;
        right: 0;
        bottom: 0;
        z-index: 2;
        overflow: auto;
        width: 100vw;
        max-width: 440px;
        box-shadow: 0 0 5px 4px rgb(0 0 0 / 11%);
    }
`;
const FilterGroup = ({ children, className }) => {
    return (_jsx(StyledFlex, { className: className, flexWrap: "nowrap", alignItems: "flex-end", children: children }));
};
export default FilterGroup;
